import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const numCastUiNodeSpec: UiNodeSpec<'numCast'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'numCast', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'varValue', label: 'Input' } }),
    kindLabel: 'Number Value Cast',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'number', label: 'Output' } }),
    validator: () => true,
};
